export default {"src":"/_next/static/media/upload-fill.e19f5183.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};